import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';

@Component({
	selector: 'df-text-box',
	templateUrl: './text-box.component.html',
	styleUrls: ['./text-box.component.scss']
})
export class TextBoxComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	constructor() {}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit(): void {}
}
